<template>
    <div>
        <div class="container-fluid">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''">
            </div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="col-12" v-html="content">
                    <!--div class="content-pages">
                        <h2 class="page-title">fashion awards</h2>
                        <p>Shoppers Stop - Best Brand – Ladies Ethnic Wear 2014<br>
                            Images most admired fashion brand of the year - 2015<br>
                            Images Most Admired Retailer FY 2015<br>
                            Shoppers Stop Pinnacle Awards -2015<br>
                            Best Women’s ethnic wear brand by Myntra -2015<br>
                            Reliance Trend best performing partner- 2015<br>
                            Asia Retail Summit -Retail marketing campaign of the year -2015<br>
                            Shoppers Stop - Best Brand – Ladies Ethnic Wear 2015
                        </p>
                        <p>Images most admired Fashion Brand of the year - 2016 (2 nd Consecutive Year)<br>
                            Awards for Retail Excellence - Retail Marketing Campaign of the year – UnlikeBoring
                            -2016<br>
                            CMO Asia, Retail Excellence Awards – Marketing Campaign of the year – UNUSUALS - 2016<br>
                            Shoppers Stop - Best Brand – Ladies Ethnic Wear 2016<br>
                            Best Turnaround Story, By Images Fashion Forum - 2016<br>
                            Images Most Admired Retailer of the Year, Brand W - 2016<br>
                            Digital Marketing Campaign of the Year - 2016, By Images<br>
                            India e-Retail Awards - Brand with outstanding e-Retail Performance - 2016</p>

                        <p>Images Most Admired Fashion Brand of the year – 2017 (3 rd consecutive Year)<br>
                            Images Most Admired Concept of the Year – Pantrobes 2017<br>
                            Lulu Retail Awards – Retailer of the Year 2017<br>
                            <b>Aurelia –</b> Best Performing Ethnic Women’s wear Brand - By Flipkart<br>
                            Shoppers Stop - Best Brand – Ladies Ethnic Wear 2017 (4 Consecutive Years)<br>
                            Images Most Admired Retailer – Store Design &amp; VM 2017, Brand W<br>
                            Most effective Campaign for Consumer - By Exchanges for Media (Maddies Mobile Marketing
                            Awards 2017)</p>

                        <p>Images Most Admired Fashion Brand of the year – 2018 (4 th Consecutive Year)<br>
                            Consumer Company of the Year By VCCircle Awards 2018<br>
                            Best Women’s Fashion Brand – W, By Lulu Retail Awards 2018<br>
                            Brand Professional of the Year 2018 – Mr. Anant Daga (M.D. - TCNS Clothing), By CMAI<br>
                            Best Strategic Partner, Women’s Wear – W &amp; Aurelia, By Flipkart 2018<br>
                            Best Search Marketing Campaign of the Year – Masters of Modern Marketing Awards 2018<br>
                            Images Most Admire Retailer of the Year - Store Design &amp; VM (By Images Retail Awards
                            2018)<br>
                            Images North India Retail Awards’ 2018- Images Most Admired Retailer of the Year: Innovative
                            Retail Concept
                            (Mughal Gown)<br>
                            Images North India Retail Awards’ 2018- Images Most Admired Retailer of the Year: Marketing
                            &amp; Promotions
                            (Inseparables)</p>
                        <p>Images Most Admired Fashion Brand of the year – 2019 (5 th Consecutive Year)<br>
                            <b>Aurelia -</b> Images Most Admired Retailer of the Year: Visual Merchandising (Disha
                            Patani Focussed VM)<br>
                            <b>Aurelia-</b> Consumer Choice Women’s Ethnic Brand of the Year, By Flipkart Fashion
                            Conclave 2019<br>
                            Most Liked Women’s Brand, ‘W’– By Myntra<br>
                            India TV-Great Lifestyle Brands: Best Social Media Campaign – Yolo Dress 2019</p>
                    </div-->

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'fashion_awards',
        metaInfo() {
            return {
                title: this.meta_title,
                meta: [
                    {
                        name: 'description',
                        content: this.meta_description
                    },
                    {
                        property: 'keywords',
                        content: this.meta_keyword
                    }
                ]
            }
        },
        data() {
            return {
                meta_title: '',
                meta_description: '',
                meta_keyword: '',
                content:''
            };
        },
        beforeMount() {
            this.$root.page_loader = true;
            axios.get(this.$root.api_url+`/pim/pimresponse.php?service=cms_page&url_key=fashion-awards&store=${this.$root.store}`)
            .then(response => {
                this.$root.page_loader = false;
                if(response.data.response.success=='1'){
                    this.$root.breadcrumb = response.data.result[0].name;
                    this.$root.page_loader = false;
                    this.content=response.data.result[0].content;
                    this.meta_title = response.data.result[0].meta_title;
                    this.meta_description = response.data.result[0].meta_description;
                    this.meta_keyword = '';
                }
                else
                {
                    this.$router.push('/404');
                }
            }).catch(error=>{
                this.$root.page_loader = false;
            })
        },
        created() {
            window.scrollTo(0, 0);
            // this.$root.breadcrumb = 'Fashion Awards';
            // if (this.$root.store === 1) {
            //     this.meta_title = 'Fashion Awards';
            //     this.meta_description = 'This section pertains to the Privacy Policy of the website. We would like to inform that our privacy policy is subject to change without intimation and you shall be required to review the same regularly.';
            //     this.meta_keyword = 'Privacy Policy';
            // }
            // else {
            //     this.meta_title = 'Fashion Awards';
            //     this.meta_description = 'Shop a wide range of women online fashionable clothes that suits every occasion - Top wear, Bottom wear, Suit Sets &amp; Dupatta. Free Shipping. COD. 15-Day Returns.';
            //     this.meta_keyword = 'online shopping for women, fashion women clothing, buy womens clothing online, shop women clothing';
            // }
        }
    }
</script>